import React from 'react';
// import { Card } from 'react-bootstrap';

const IdentificazioneRischiEtMitigazioni = () => {
  return (<></>);
};

export default IdentificazioneRischiEtMitigazioni;
